import React from 'react';
import styled from 'styled-components';
import { Typography } from 'vlab-frontend-components';
import Translator from '../../../../components/i18n/translator';
interface ErrorProps {
  label: string;
}

const ErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 80vh;
  padding-top: 52px;
  width: 100%;
`;

const Error = ({ label }: ErrorProps) => {
  return (
    <ErrorContainer>
      <Typography type="subheadingL" color="black">{label}</Typography>
      <Typography type="subheadingM" color="blackLight">
        <Translator path="home.tryAdmContact" />
      </Typography>
    </ErrorContainer>
  );
};

export default Error;
